export const universalDateParser = (date) => {
  return date
    ? typeof date === "string"
      ? new Date(date.replace(" ", "T") + "Z")
      : date
    : new Date();
};
